import Admin from "../Admin";
import React from "react";
import CardAdminOrderStatusReasonList from "../../../Component/Card/Admin/OrderStatusReason/CardAdminOrderStatusReasonList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminOrderStatusReasonList extends Admin {

    /**
     * Render the content.
     */
    renderContent() {
        return (
            <CardAdminOrderStatusReasonList />
        );
    }

    renderHeader() {
        const handleClickCreate = () => {
            this.props.history.push({
                pathname: "/admin/orderStatusReason"
            });
        };

        const buttons = [
            (<MUIButton
                component="label"
                variant="contained"
                startIcon={<MUIAddIcon />}
                onClick={handleClickCreate}>Create New</MUIButton>),
        ];

        return (
            <PageHeader title="Order Status Reasons" buttons={buttons} />
        );
    }
}
